import React from "react";
import { Reveal } from "@/components/Reveal";
import { Sparkles, Sun, Heart } from "lucide-react";

export default function BrandStory({ settings }) {
  const pillars = [
    { icon: Sun, title: "Kleur & energie", text: "Elke fles is een zonsondergang in een glas — gemaakt om op te vallen." },
    { icon: Sparkles, title: "Smaakbeleving", text: "Exotische smaakprofielen die uw kaart onderscheidend maken." },
    { icon: Heart, title: "Gastvrijheid", text: "Drankconcepten die gasten laten terugkomen, keer op keer." },
  ];
  return (
    <section className="relative overflow-hidden bg-sfc-night px-5 py-28 lg:px-10">
      <div className="mx-auto grid max-w-7xl gap-16 lg:grid-cols-2 lg:items-center">
        <Reveal>
          <span className="text-xs font-semibold uppercase tracking-[0.3em] text-sfc-cyan">Ons verhaal</span>
          <h2 className="mt-5 font-display text-4xl font-semibold leading-tight tracking-tight text-white sm:text-5xl">
            Waar smaak <span className="text-gradient-sunset">tot leven komt</span>.
          </h2>
          <p className="mt-6 text-base leading-relaxed text-white/70 sm:text-lg">
            {settings?.brand_story ||
              "Soul Food City Drinks is geboren uit liefde voor kleur, gastvrijheid en onvergetelijke smaakbeleving."}
          </p>
          <div className="mt-10 grid gap-6 sm:grid-cols-3">
            {pillars.map((p) => (
              <div key={p.title} className="rounded-3xl border border-white/10 bg-white/[0.03] p-5">
                <p.icon className="text-sfc-orange" size={26} />
                <h3 className="mt-3 font-display text-base text-white">{p.title}</h3>
                <p className="mt-1.5 text-sm text-white/60">{p.text}</p>
              </div>
            ))}
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="relative overflow-hidden rounded-[2.5rem] border border-white/10">
            <img
              src="https://images.pexels.com/photos/1189261/pexels-photo-1189261.jpeg"
              alt="Barman schenkt een exotische drank in"
              loading="lazy"
              className="aspect-[4/5] w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-sfc-purple/70 via-transparent to-transparent" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
